import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import { CarouselComponent } from "../CarouselComponent";
import { LocationOn } from "@mui/icons-material";

const arr1 = [
  "/images/construction1.png",
  "/images/construction2.png",
  "/images/construction3.png",
  "/images/construction5.png",
  "/images/construction6.png",
];

const arr2 = [
  "/images/telecom1.png",
  "/images/telecom2.png",
  "/images/telecom3.png",
  "/images/telecom4.png",
];

const arr3 = [
  "/images/telecom1800_2000_1.png",
  "/images/telecom1800_2000_2.png",
  "/images/telecom1800_2000_3.png",
  "/images/telecom1800_2000_4.png",
  "/images/telecom1800_2000_5.png",
];

const arr4 = [
  "/images/architecture1.png",
  "/images/architecture2.png",
  "/images/architecture3.png",
  "/images/architecture4.png",
  "/images/architecture5.png",
  "/images/architecture6.png",
];

export const ExperienceContent = ({ translate }) => {
  return (
    <Stack direction="column" spacing={1}>
      <Box data-aos="fade-up" data-aos-offset="200">
        <Typography variant="h5">
          <b>{translate("experinceHeadOne")}</b>
        </Typography>
      </Box>
      <Box
        sx={{ display: "flex", alignItems: "center", marginLeft: "10px" }}
        data-aos="fade-up"
        data-aos-offset="200"
      >
        <LocationOn sx={{ marginRight: "10px" }} />
        <Typography variant="h6">
          <b>{translate("experinceBodyOne")}</b>
        </Typography>
      </Box>
      <Box data-aos="fade-up" data-aos-offset="200">
        <CarouselComponent
          translate={translate}
          arrPicture={arr1}
          caption={"experinceBodyOne"}
        />
      </Box>
      <Box data-aos="fade-up" data-aos-offset="200">
        <Typography variant="h5">
          <b>{translate("experinceHeadTwo")}</b>
        </Typography>
      </Box>
      <Box
        sx={{ display: "flex", alignItems: "center", marginLeft: "10px" }}
        data-aos="fade-up"
        data-aos-offset="200"
      >
        <LocationOn sx={{ marginRight: "10px" }} />
        <Typography variant="h6">
          <b>{translate("experinceBodyTwo1")}</b>
        </Typography>
      </Box>
      <Box data-aos="fade-up" data-aos-offset="200">
        <CarouselComponent
          translate={translate}
          arrPicture={arr2}
          caption={"experinceBodyTwo1"}
        />
      </Box>
      <Box
        sx={{ display: "flex", alignItems: "center", marginLeft: "10px" }}
        data-aos="fade-up"
        data-aos-offset="200"
      >
        <LocationOn sx={{ marginRight: "10px" }} />
        <Typography variant="h6">
          <b>{translate("experinceBodyTwo2")}</b>
        </Typography>
      </Box>
      <Box data-aos="fade-up" data-aos-offset="200">
        <CarouselComponent
          translate={translate}
          arrPicture={arr3}
          caption={"experinceBodyTwo2"}
        />
      </Box>
      <Box data-aos="fade-up" data-aos-offset="200">
        <Typography variant="h5">
          <b>{translate("experinceHeadThree")}</b>
        </Typography>
      </Box>
      <Box
        sx={{ display: "flex", alignItems: "center", marginLeft: "10px" }}
        data-aos="fade-up"
        data-aos-offset="200"
      >
        <LocationOn sx={{ marginRight: "10px" }} />
        <Typography variant="h6">
          <b>{translate("experinceBodyThree")}</b>
        </Typography>
      </Box>
      <Box data-aos="fade-up" data-aos-offset="200">
        <CarouselComponent
          translate={translate}
          arrPicture={arr4}
          caption={"experinceBodyThree"}
        />
      </Box>
    </Stack>
  );
};
